import React, { useEffect, useState } from 'react';
import walletCard from '../../assets/images/wallet.svg';
import { Button, notification, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useGetUserWalletQuery } from '../../../user_profile/userProfileSlice';

const spinIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export default function UserBookingWalletBalance({
  payableAmountPence = 0,
  amountInUse = null,
  defaultUsingBalance = false,
  setUsingWalletAmountPence = (newAmount) => {},
}) {
  const {
    data: { balance_in_pence: balancePence } = {
      balance_in_pence: 0,
    },
    isFetching: loading,
  } = useGetUserWalletQuery();
  const [usingBalance, setUsingBalance] = useState(defaultUsingBalance);
  useEffect(() => {
    setUsingBalance(defaultUsingBalance);
  }, [defaultUsingBalance]);

  const disabled = loading || !balancePence;

  return (
    <div className='row-center gap-05r pd-10 br10 border-2 border-light-grey mg-bottom-2'>
      <img
        src={walletCard}
        alt='wallet card'
        style={{ marginTop: '-4px', marginBottom: '-6px' }}
      />
      <div style={{ flexGrow: 1 }}>
        <p className='mg-bottom-0 fs-12 gSemiBold' style={{ color: '#262626' }}>
          Wallet Balance
        </p>
        <p
          className='mg-bottom-0 gMedium fs-18 lh-1'
          style={{ color: '#818181' }}
        >
          {loading ? (
            <Spin indicator={spinIcon} />
          ) : (
            `£${((balancePence - amountInUse ?? 0) / 100).toFixed(2)}`
          )}
        </p>
      </div>
      <Button
        className={
          'gSemiBold br20 fs-14 txt-center h-full pd-5 pd-left-15 pd-right-15'
        }
        style={{
          whiteSpace: 'normal',
          backgroundColor: disabled
            ? '#f5f5f5'
            : usingBalance
              ? '#BC1F1F'
              : '#202020',
          color: disabled ? '#9c9c9c' : 'white',
          cursor: disabled ? 'not-allowed' : 'pointer',
          border: 'none',
          minWidth: '6.5rem',
        }}
        disabled={loading}
        onClick={() => {
          if (disabled) {
            notification.warning({
              message: (
                <div className='gSemiBold'>
                  You don't have any wallet balance!
                </div>
              ),
              style: { border: '1px #F7C046 solid' },
              placement: window?.innerWidth <= 500 ? 'top' : 'topRight',
              className: 'gRegular br10',
              description:
                'Make a booking to earn some cashback and add to your SB+ Wallet!',
            });
            return;
          }
          setUsingBalance((prev) => {
            const currentlyUsing = !prev;
            setUsingWalletAmountPence(
              currentlyUsing ? Math.min(balancePence, payableAmountPence) : null
            );
            return currentlyUsing;
          });
        }}
      >
        {usingBalance ? 'Undo' : 'Use Credit'}
      </Button>
    </div>
  );
}
